import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';

/** Moduler som huvudadmin slår på och av per kund. */
export type ModuleKey = 'device_schedules' | 'inspections' | 'heatpump' | 'shelly';
export type ModuleState = Record<ModuleKey, boolean>;

/** Den inloggade kundens moduler (menyn döljer det som är av). */
export const fetchModules = async (): Promise<ModuleState> => {
    try { return (await axios.get<ModuleState>(`${API_BASE_URL}/modules`)).data; }
    catch (e) { return handleApiError(e, 'Hämta moduler'); }
};

export interface TenantModules { modules: ModuleState; labels: Record<ModuleKey, string> }

export const fetchTenantModules = async (tenantId: string): Promise<TenantModules> => {
    try { return (await axios.get<TenantModules>(`${API_BASE_URL}/superuser/tenants/${encodeURIComponent(tenantId)}/modules`)).data; }
    catch (e) { return handleApiError(e, 'Hämta kundens moduler'); }
};

export const setTenantModule = async (tenantId: string, module: ModuleKey, enabled: boolean): Promise<TenantModules> => {
    try { return (await axios.put<TenantModules>(`${API_BASE_URL}/superuser/tenants/${encodeURIComponent(tenantId)}/modules`, { module, enabled })).data; }
    catch (e) { return handleApiError(e, 'Ändra modul'); }
};
